<template>
	<div class="table-wrap communication">
		<div class="search-bar">		
			<el-form ref="form" label-width="120px" v-loading="isLoading">
				<label>日期
					<el-date-picker size="small" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
				</label>
				<template>
					<div style="display: inline-block;">沟通方式
						<el-select size="small" filterable clearable v-model="filter.recordType" placeholder="请选择" @change="handleFilter(1, $event)">
							<el-option label="电话" :value="1"></el-option>
							<el-option label="短信" :value="2"></el-option>
						</el-select>
					</div>
				</template>
				<label>操作人
					<el-input size="small" maxlength="18" style="width:100px" v-model.trim="filter.receiver" @keyup.enter.native="handleFilter(0, $event)"></el-input>
				</label>
				
				<el-button type="primary" size="mini" round @click="handleFilter(1, $event)">查询</el-button>
			</el-form>
		</div>

		<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
			<el-table-column prop="recordTime" label="时间" show-overflow-tooltip></el-table-column>
			<el-table-column prop="phone" label="电话"></el-table-column>
			<el-table-column prop="typeStr" label="方式" width="120"></el-table-column>
			<el-table-column prop="childTypeStr" label="类型" show-overflow-tooltip>
				<template slot-scope="scope">
					{{ scope.row.type=='2'?`${scope.row.childTypeStr}：${scope.row.stateStr}`:scope.row.childTypeStr}}
				</template>
			</el-table-column>
			<el-table-column prop="creator" label="操作人" width="100"></el-table-column>
			<el-table-column label="内容">
				<template slot-scope="scope">
					<div v-if="scope.row.type == 1">
						<template v-if="hospitalCode=='AH_FY1'">
							<span>无录音内容</span>
						</template>
						<template v-else>
							<el-button type="danger" size="mini" round v-if="scope.row.state=='99'" @click="getSynchronization(scope.row)">点击同步</el-button>
							<span v-if="(scope.row.state=='1'||scope.row.state=='0')&&!scope.row.communicationContent">无录音文件</span>
							<span style="color: #909399;" v-if="scope.row.state=='1'&&scope.row.communicationContent&&!permission">无下载录音权限</span>
							<a v-if="scope.row.state=='1'&&scope.row.communicationContent&&permission" class="round primary" target="_blank" :href="scope.row.communicationContent"><i class="icon-export"></i>下载录音文件</a>
						</template>
					</div>
					<span v-if="scope.row.type == 2" v-text="scope.row.communicationContent"></span>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-row>
				<el-col :span="12">
					<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
					<div class="record">总计<span v-text="list.total"></span>条记录</div>
				</el-col>
				<el-col :span="12" style="text-align: right;">
					<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
						
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	props: {
		patientId: {required: true}
	},
	watch: {
		patientId(newV, oldV) {
			if (newV && (newV != oldV)) {
				this.loadList();			
			}
		}
	},	
	data(){
		return {
			noSidebar: true,
			hospitalCode:'',
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				patientId:0, //患者id
				date:[],
				start:'', //开始时间
				end:'',	//结束时间
				recordType:'',	// 记录类型（1电话2短信）
				receiver:'', //操作人姓名
				pageNumber:1,
				pageSize:10
			},
			permission:false,
			GXcallFlag:false,
			UboxCallFlag:false
		}
	},
	async created() {
		if (this.patientId) {
			this.loadList();
		}
		this.GXcallFlag=await api.getGXcallFlag();
		this.UboxCallFlag=await api.getUboxCallFlag();
	},
	mounted (){
		this.init();	
	},
	methods: {
		async init() {
			this.hospitalCode=await api.getHospitalCode();
		},
		async loadList() {
			this.isLoading = false;
			this.filter.patientId = this.patientId;
			let res = await api.getCommunicationList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
			res.data.forEach((item)=>{
				item.recordTime = dayjs(item.recordTime).format('YYYY-MM-DD HH:mm:ss');
			})
			this.list.data = res.data;
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
			this.isLoading = false;
		},		
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 0:
					if (this.filter.date) {
						this.filter.start = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.end = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.start = '';
						this.filter.end = '';						
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},				
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		async getSynchronization(item){
			// 同步录音文件
			if(this.GXcallFlag){
				let res = await api.getSynchronization({"communicationRecordId":item.id})
				if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			} else if(this.UboxCallFlag){
				window.UploadFormFile(item.recording,item.id);
				// 分割路径为各部分
				// const parts = item.recording.split('\\');
				// let date;
				// let filename;
				// if (parts.length > 2) {
				// 	date = parts[parts.length - 2];
				// 	const filenameWithExtension = parts[parts.length - 1];
				// 	filename = filenameWithExtension.split('.')[0];
					
				// 	console.log('Date:', date);  // 输出：2023-08
				// 	console.log('Filename:', filename);  // 输出：13188935699-30173741
				// }
				// --// window.UploadFormFile(item.recording,item.id);////ubox同步呼叫
			}
			setTimeout(() => {
				this.loadList();
			}, 500);
		},
	}
}
</script>

<style lang="less" scoped>
@import './user-bio.less';
</style>
